import * as React from "react";
import "./PanelPage.css";
import { ClassNames } from "src/_helpers/ClassNames";
import Image from "../Image/Image";

export type PanelPageProps = PanelPageDto;

export class PanelPage extends React.Component<PanelPageProps> {
  constructor(props: PanelPageProps) {
    super(props);
  }
  render() {
    const { Leaves } = this.props;

    return (
      <div className={ClassNames("panel-page", "")}>
        {Leaves.map((leaf, i) => {
          switch (leaf.type) {
            case "PanelImage":
              const image = leaf as PanelImageDto;
              const ratio = image.Image.Height / image.Image.Width;
              const portrait = ratio >= 1;
              return portrait ? (
                <div
                  key={`panel-${i}`}
                  className={ClassNames("panel-page", "figure-outer")}
                >
                  <figure
                    className={ClassNames("panel-page", "figure", "portrait")}
                  >
                    <Image
                      pictureRef={image.Image}
                      className={ClassNames("panel-page", "image")}
                      sizes={`(max-width: 770px) 100vw, (min-width: 771px) 800px`}
                    />
                  </figure>
                </div>
              ) : (
                <figure
                  key={`panel-${i}`}
                  className={ClassNames("panel-page", "figure", "landscape")}
                >
                  <Image
                    pictureRef={image.Image}
                    className={ClassNames("panel-page", "image")}
                    sizes={`(max-width: 1280px) 100vw, (min-width: 1281px) 1300px`}
                  />
                </figure>
              );
            case "PanelText":
              const text = leaf as PanelTextDto;
              return (
                <div
                  key={`panel-${i}`}
                  className={ClassNames("panel-page", "text")}
                >
                  {text.IsPolicyPanel && (
                    <span
                      id="policy-panel"
                      className={ClassNames("panel-page", "policy-panel")}
                    />
                  )}
                  {text.Title && (
                    <h3 className={ClassNames("panel-page", "title")}>
                      {text.Title}
                    </h3>
                  )}
                  <div
                    className={ClassNames("panel-page", "text-content")}
                    dangerouslySetInnerHTML={{
                      __html: text.Text,
                    }}
                  />
                </div>
              );
            default:
              return null;
          }
        })}
      </div>
    );
  }
}

export default PanelPage;



// WEBPACK FOOTER //
// ./src/Components/PanelPage/PanelPage.tsx